import { currencySymbol } from "pages/price/PriceWithCurrency";
import AmountChartView from "./AmountChartView";

const SalesView = ({ startYear, endYear, records, currency, customerData }) => {
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i,
  );

  const salesAmountByYear = records.reduce((acc, item) => {
    const year = Number(String(item.month).slice(0, 4));
    if (!years.includes(year)) return acc;

    if (!acc[year]) {
      acc[year] = 0;
    }

    acc[year] += item.total_amount_in_target_currency ?? 0;

    return acc;
  }, {});

  const qtyByYear = records.reduce((acc, item) => {
    const year = Number(String(item.month).slice(0, 4));
    if (!years.includes(year)) return acc;

    if (!acc[year]) {
      acc[year] = 0;
    }

    acc[year] += item.total_qty || 0;

    return acc;
  }, {});

  const marginByYear = records.reduce((acc, item) => {
    const year = Number(String(item.month).slice(0, 4));
    if (!years.includes(year)) return acc;

    if (!acc[year]) {
      acc[year] = { margin: 0, amount: 0 };
    }

    acc[year].margin += item.total_margin_in_company_currency ?? 0;
    acc[year].amount += item.total_amount_in_company_currency ?? 0;

    return acc;
  }, {});

  const reportData = customerData?.customer?.reportData
    ? JSON.parse(customerData.customer.reportData)
    : null;
  const budgetsByYear = (reportData?.salesBudgets || []).reduce((acc, item) => {
    const year = Number(item.year);
    if (!years.includes(year)) return acc;

    if (!acc[year]) {
      acc[year] = 0;
    }

    acc[year] += Number(item.amount || 0);

    return acc;
  }, {});
  const hasCustomerData = Boolean(customerData?.customer);

  const amountRows = years.map((year) => ({
    year,
    salesAmount: salesAmountByYear[year] || 0,
    totalQty: qtyByYear[year] || 0,
    budgetAmount: budgetsByYear[year] || 0,
    marginPercent:
      marginByYear[year] && marginByYear[year].amount
        ? (marginByYear[year].margin / marginByYear[year].amount) * 100
        : 0,
  }));

  return (
    <div className="card">
      <h5>Sales</h5>

      <div className="mt-4">
        <AmountChartView
          records={records}
          startYear={startYear}
          endYear={endYear}
        />
      </div>

      <div className="mt-2 -mx-1">
        <div className="font-code">
          <table className="with-border">
            <thead>
              <tr>
                <th>Year</th>
                <th className="text-right">Total QTY</th>
                <th className="text-right">Sales</th>
                {hasCustomerData && <th className="text-right">Budget(USD)</th>}
                <th className="text-right">Margin</th>
              </tr>
            </thead>
            <tbody>
              {amountRows.map((row) => (
                <tr key={row.year}>
                  <td>{row.year}</td>
                  <td className="text-right">
                    {row.totalQty.toLocaleString()}
                  </td>
                  <td className="text-right">
                    {currencySymbol(currency)}{" "}
                    {row.salesAmount.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  {hasCustomerData && (
                    <td className="text-right">
                      {currencySymbol("USD")}{" "}
                      {row.budgetAmount.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                  )}
                  <td className="text-right">
                    {row.marginPercent.toFixed(2)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-2 text-xs opacity-70">
        Note that margin here is calculated base on the sales order line margins
        provided by Odoo. This is different from the odoo invoice margin.
      </div>
    </div>
  );
};

export default SalesView;
